/* unplugin-vue-components disabled */import script from "./ScheduleDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleDetailModal.vue?vue&type=style&index=0&id=2e1794ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1794ba"]])

export default __exports__